import {SnackbarContent, CustomContentProps} from "notistack";
import React from "react";
import TaskAltSharpIcon from '@mui/icons-material/TaskAltSharp';



const CustomSuccess = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {

    const {
        message
    } = props

    return (
        <SnackbarContent ref={ref}>
            <div className="alert alert--success" style={{minWidth: "250px"}}>
                <div className="alert__prefix">
                    <TaskAltSharpIcon />
                </div>
                <div className="alert__header">{message}</div>
            </div>
        </SnackbarContent>
    )
})

export {CustomSuccess}